import { io } from "socket.io-client";

const SOCKET_URL = "https://hrmsapi.iihglobal.net";
console.log("SOCKET_URL", SOCKET_URL);
const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ["websocket"],
});

export default socket;
